import Styled from 'styled-components'
import { lighten } from 'polished'

export default Styled.div`
  font-family: ${props => props.theme.fonts.regular};
  padding: 0.5rem 1rem;
  border-bottom: 1px solid ${props => lighten(0.025, props.theme.colors.gray.shade100)};
  color: ${props => props.theme.colors.text};
  transition: background .3s;
  font-size: 0.85rem;
  cursor: pointer;

  &:hover, &:focus {
    background: ${props => lighten(0.05, props.theme.colors.gray.shade100)};
  }

  &:first-child {
    border-top-left-radius: ${props => props.theme.radius};
    border-top-right-radius: ${props => props.theme.radius};
  }

  &:last-child {
    border-bottom-left-radius: ${props => props.theme.radius};
    border-bottom-right-radius: ${props => props.theme.radius};
    border-bottom: 0;
  }
`



// WEBPACK FOOTER //
// ./src/components/DropdownListItem/index.js